import { track } from './analytics';
import { titleForPath } from './page-titles';

let lastTrackedPath: string | null = null;

/**
 * Fire a GA4 `page_view` (and sync `document.title`) when the path actually
 * changes. The data router's `subscribe` fires on every state change, so the
 * path guard dedupes non-navigation updates (fetcher state, revalidation).
 */
export function trackPageView(pathname: string): void {
  if (pathname === lastTrackedPath) return;
  lastTrackedPath = pathname;

  const title = titleForPath(pathname);
  document.title = title === 'Polymyth' ? 'Polymyth' : `${title} · Polymyth`;

  track('page_view', {
    page_title: title,
    page_location: window.location.href,
    page_path: pathname,
  });
}
